import React from 'react';
import PropTypes from 'prop-types';
import validator from 'lib/validator';

import { Button } from 'components/common';
import { TextField } from 'components/formFields';
import { FormManager, Form, GeneralError } from 'lib/form';
import { useAuth } from 'lib/auth';

const initialValues = {
  email: '',
};

const validationSchema = validator.object({
  email: validator.string().email().required(),
});

const ForgotPasswordForm = ({ onSendEmail }) => {
  const { sendResetPasswordEmail } = useAuth();

  const handleOnSubmit = async ({ email }, actions) => {
    try {
      actions.setStatus({ error: null });
      const response = await sendResetPasswordEmail({ email });

      onSendEmail(null, response);
    } catch (err) {
      onSendEmail(err, null);

      actions.setErrors(err.errors);
      if (err.errors?.message) {
        actions.setStatus({ error: err.errors?.message });
      }
    }
  };

  return (
    <FormManager
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleOnSubmit}
    >
      {() => (
        <Form>
          <GeneralError />
          <TextField
            name="email"
            type="email"
            label="Email"
            required
          />

          <Button type="submit" variant="outlined">
            Send Password Reset Email
          </Button>
        </Form>
      )}
    </FormManager>
  );
};

ForgotPasswordForm.propTypes = {
  onSendEmail: PropTypes.func,
};

ForgotPasswordForm.defaultProps = {
  onSendEmail: () => {},
};

export default ForgotPasswordForm;
